import { useTheme } from '@react-navigation/native'
import React from 'react'
import { StyleSheet, View } from 'react-native'
import { Spinner } from '../display'

export function DefaultLoading() {
  const styles = useStyles()

  return (
    <View style={styles.container}>
      <Spinner size={48} />
    </View>
  )
}

const useStyles = () => {
  const theme = useTheme()
  return StyleSheet.create({
    container: {
      minHeight: 200,
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
    },
    loading: {
      color: theme.colors.text,
    },
  })
}
